import { createConsts, createActions } from '../../utils/redux';

const types = [
  'CREATED',
  'UPDATED',
  'PIN',
  'CHANGE_ROOM',
  'CHANGE_STATUS',
  'CHANGE_PAYMENT_STATUS',
  'UPDATE_COPAY',
  'REMOVE_FROM_DASHBOARD',
];
export const consts = createConsts('dashboard', 'real-time-updates', ...types);
export const actions = createActions(consts);



// WEBPACK FOOTER //
// ./src/redux/dashboard/real-time-updates.js